// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__yJIQA","sidebarWrapper":"MainLayout_sidebarWrapper__Y4RIl","sectionWrapper":"MainLayout_sectionWrapper__J5nHK"};